import { render, staticRenderFns } from "./CitySingle.vue?vue&type=template&id=12770718&"
import script from "./CitySingle.vue?vue&type=script&lang=js&"
export * from "./CitySingle.vue?vue&type=script&lang=js&"
import style0 from "./CitySingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports